
import { defineComponent, ref, Ref } from 'vue'

// @components
import NewButton from '@/ui-kit/NewButton/index.vue'

// @composable
import { useOnOutsidePress } from 'vue-composable'

export default defineComponent({
    name: 'new_modal',
    components: {
        NewButton,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        isGrey: {
            type: Boolean,
            default: false,
        },
        confirmButtonText: {
            type: String,
            default: 'Подтвердить',
        },
        confirmButtonClass: {
            type: String,
            default: 'small primary',
        },
        cancelButtonText: {
            type: String,
            default: 'Отмена',
        },
        cancelButtonClass: {
            type: String,
            default: 'NewButton--outline mr-3',
        },
        confirmDisabled: {
            type: Boolean,
            default: false,
        },
        overflow: {
            type: Boolean,
            deafult: true,
        },
        maxContent: {
            type: Boolean,
            deafult: true,
        },
        withCancelButton: {
            type: Boolean,
            deafault: true,
        },
        withoutFooter: {
            type: Boolean,
            default: false,
        },
        transparentHeader: {
            type: Boolean,
            default: false,
        },
        canBack: {
            type: Boolean,
            default: false,
        },
        outsideClose: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['cancel', 'submit', 'back'],
    setup(props, { emit }) {
        const elementref: Ref<HTMLElement | null> = ref(null)

        const emitCancel = () => {
            emit('cancel')
        }

        const emitSubmit = () => {
            emit('submit')
        }

        const emitBack = () => {
            emit('back')
        }

        useOnOutsidePress(elementref, () => {
            if (props.outsideClose) {
                emitCancel()
            }
        })

        return {
            elementref,
            //
            emitCancel,
            emitSubmit,
            emitBack,
        }
    },
})
